import { defineStore } from 'pinia'

interface EscalationNotice {
  id: number
  conversationId: number
  escalatedAt: string
}

interface WhatsappRealtimeState {
  unreadConversationIds: number[]
  escalatedConversationIds: number[]
  escalationNotices: EscalationNotice[]
  nextNoticeId: number
}

export const useWhatsappRealtimeStore = defineStore('whatsapp-realtime', {
  state: (): WhatsappRealtimeState => ({
    unreadConversationIds: [],
    escalatedConversationIds: [],
    escalationNotices: [],
    nextNoticeId: 1,
  }),
  getters: {
    unreadCount: (state): number => state.unreadConversationIds.length,
    escalationCount: (state): number => state.escalatedConversationIds.length,
  },
  actions: {
    markConversationUnread(conversationId: number) {
      if (this.unreadConversationIds.includes(conversationId)) return
      this.unreadConversationIds = [...this.unreadConversationIds, conversationId]
    },
    markConversationRead(conversationId: number) {
      this.unreadConversationIds = this.unreadConversationIds.filter((id) => id !== conversationId)
      this.escalatedConversationIds = this.escalatedConversationIds.filter((id) => id !== conversationId)
      this.escalationNotices = this.escalationNotices.filter((notice) => notice.conversationId !== conversationId)
    },
    addEscalation(conversationId: number, escalatedAt: string) {
      if (!this.escalatedConversationIds.includes(conversationId)) {
        this.escalatedConversationIds = [...this.escalatedConversationIds, conversationId]
      }

      const alreadyQueued = this.escalationNotices.some((notice) =>
        notice.conversationId === conversationId && notice.escalatedAt === escalatedAt,
      )
      if (alreadyQueued) return

      this.escalationNotices = [
        ...this.escalationNotices,
        {
          id: this.nextNoticeId++,
          conversationId,
          escalatedAt,
        },
      ]
    },
    dismissEscalationNotice(noticeId: number) {
      this.escalationNotices = this.escalationNotices.filter((notice) => notice.id !== noticeId)
    },
    clearEscalationByConversation(conversationId: number) {
      this.escalatedConversationIds = this.escalatedConversationIds.filter((id) => id !== conversationId)
      this.escalationNotices = this.escalationNotices.filter((notice) => notice.conversationId !== conversationId)
    },
    reset() {
      this.unreadConversationIds = []
      this.escalatedConversationIds = []
      this.escalationNotices = []
      this.nextNoticeId = 1
    },
  },
})
